import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { IconWrapper } from '@flexo/general';
import { ALERT, alertCallbackStore } from '@flexo/reducers';
import Button from '../../button/button';
import styles from './../alert.module.scss';

export default function AlertApiKeyCreated() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [copied, setCopied] = useState(false);

  const content = t('widgets.apiKeys', { returnObjects: true }) as any;
  const data = alertCallbackStore.getData();
  const apiKey = data?.apiKey || '';

  const handleCopy = () => {
    if (apiKey) {
      navigator.clipboard.writeText(apiKey);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleClose = () => {
    alertCallbackStore.clearAll();
    dispatch(ALERT.ResetAlert({} as any));
  };

  return (
    <div>
      <div
        id="alert-api-key-created"
        className={`${styles.Alert} ${styles.Alert__Confirm__Credentials__Changes}`}
      >
        <div className={styles.Alert__Title__Warning}>
          <div>
            <IconWrapper iconName="alert" />
            {content.keyCreated}
          </div>
        </div>

        <div className={styles.Alert__Content}>
          {content.copyWarning}
        </div>

        <div
          style={{
            marginTop: '12px',
            padding: '10px 12px',
            backgroundColor: 'var(--hive-greyscale-200)',
            borderRadius: '8px',
            fontFamily: 'monospace',
            fontSize: '13px',
            wordBreak: 'break-all',
            color: 'var(--hive-greyscale-900)',
          }}
        >
          {apiKey}
        </div>

        <div className={`${styles.Alert__Footer__Actions} mt-2`}>
          <Button
            variant="secondary"
            color="grey"
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Cancel}`}
            label={t('common.close', { defaultValue: 'Close' })}
            onClick={handleClose}
          />
          <Button
            className={`${styles.Alert__Footer__Actions__Button} ${styles.Alert__Footer__Actions__Button__Confirm}`}
            variant="primary"
            color="secondary"
            label={copied ? t('widgets.apiKeys.keyCopied') : content.copyKey}
            onClick={handleCopy}
          />
        </div>
      </div>
    </div>
  );
}
